/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { faBars, faPlus, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container, Modal, ModalBody, ModalHeader } from "reactstrap";
import logo from "../../img/logo.svg";
import { Button } from "../Helper/Button";
import { logoutUser } from "../scenes/Auth/actions";

const Logo = () => {
    return (
        <Link to="/" >
            <img src={logo} alt="" css={css`height: 48px; padding-bottom: 8px;`} />
        </Link>
    );
};
export const navItem = css`
    color: black;
    min-width: 2.5rem;
`;

export const headerWrapper = css`
    min-height: 56px;

    @media (min-width: 992px) {
        height: 72px;
    }
`;

const styles = {
    navItem,
    headerWrapper
};







function NavToggle({ open, toggleNav, className }) {
    return (
        <Button color="light" className={className} css={styles.navItem} onClick={() => toggleNav(!open)} icon={open ? faTimes : faBars} />
    );
}

const NavMobile = ({ children, isOpen, toggleNav }) => (
    <Modal isOpen={isOpen} modalClassName="slide-in" backdropClassName="slide-in">
        <ModalHeader className="d-flex justify-content-end" css={css`height: 64px;`}>
            <NavToggle open={isOpen} toggleNav={toggleNav} className="ratio ratio-1x1" />
        </ModalHeader>

        <ModalBody className="max-h-100 overflow-y-auto px-4">
            {children}
        </ModalBody>
    </Modal>
);

export default function Header() {
    const [isMobileNavOpen, toggleMobileNav] = useState(false);
    const authenticated = useSelector(state => state.auth.authenticated);
    const user = useSelector(state => state.auth.user);
    const navigate = useNavigate();
    const logoutHandler = () => {
        logoutUser();
    };

    const addClaimHandler = () => {
        sessionStorage.removeItem("add_claim_post");
        navigate("/add-claim");
    };

    const renderLinks = () => {
        if (authenticated) {
            return [
                (user?.is_lely_superuser || user?.is_lna_superuser) && (
                    <li className="nav-item" key="claims">
                        <Link className="nav-link" to="/">Claims</Link>
                    </li>
                ),
                (user?.is_lely_superuser || user?.is_lna_superuser) && (
                    <li className="nav-item" key="admin">
                        <Link className="nav-link" to={user?.is_lely_superuser ? "/_admin/items" : "/_admin/add-wr-number"}>Admin</Link>
                    </li>
                ),
                <li className="nav-item" key="logout">
                    <span className="nav-link btn-link" onClick={logoutHandler} href="#">Logout</span>
                </li>,
            ].filter(Boolean);
        } else {
            return [
                <li className="nav-item" key="login">
                    <Link className="nav-link" to="/login">Login</Link>
                </li>
            ];
        }
    };

    const mainLinks = renderLinks();


    return (
        <div className="bg-white w-100" css={css`box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12); transition: color 0.3s ease-in;`}>
            <div >
                <Container fluid className=" d-flex align-items-center justify-content-between w-100" css={styles.headerWrapper}>
                    {/* MOBILE NAV */}
                    {/* @TODO: make this into a drawer/modal? */}
                    <div className="d-lg-none w-100 bg-white">
                        <div className="w-100 d-flex py-2 justify-content-between align-items-center">
                            <Logo />
                            <Button className="btn ms-auto me-2" color="primary" onClick={addClaimHandler}><FontAwesomeIcon icon={faPlus} /> Add Claim</Button>
                            <NavToggle open={isMobileNavOpen} toggleNav={toggleMobileNav} className={isMobileNavOpen ? "opacity-0" : ""} />
                        </div>

                        <NavMobile isOpen={isMobileNavOpen} toggleNav={toggleMobileNav}>
                            <div className="w-100">
                                <div className="navbar py-0">
                                    <ul className="navbar-nav py-0 w-100">
                                        {mainLinks}
                                    </ul>
                                </div>
                            </div>
                        </NavMobile>

                    </div>

                    {/* TABLET + DESKTOP NAV */}
                    <div className="w-100 d-none d-lg-flex align-items-center justify-content-between">
                        <Logo />

                        <div className="w-100 d-flex align-items-center">

                            <div className="ms-auto">
                                <div className="navbar navbar-expand-lg">
                                    <ul className="d-flex navbar-nav justify-content-end w-100 align-items-center">
                                        <li className="nav-item" key="add-claim">
                                            <Button className="btn " color="primary" onClick={addClaimHandler}><FontAwesomeIcon icon={faPlus} /> Add Claim</Button>
                                        </li>
                                        {mainLinks}
                                    </ul>
                                </div>
                            </div>


                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
}
